module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-800.ae844525.woff";